import { render, staticRenderFns } from "./UserExtensionsDetail.vue?vue&type=template&id=b401f5de&"
import script from "./UserExtensionsDetail.vue?vue&type=script&lang=js&"
export * from "./UserExtensionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserExtensionsDetail.vue?vue&type=style&index=0&id=b401f5de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports